import { ReceiptAnimatedWrapper } from './ReceiptAnimatedWrapper';
import { ReceiptClaimContainer } from './ReceiptClaimContainer';
import { ReceiptClaimSuccess } from './ReceiptClaimSuccess';

export const Claim = {
  Container: ReceiptClaimContainer,
  AnimatedWrapper: ReceiptAnimatedWrapper,
  Success: ReceiptClaimSuccess,
};
